import React, { useEffect, useState } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { Modal, Button } from 'react-bootstrap';
import Api from '../../Services/Api';
import Alert from '../../Services/Alert';
import { PERMISSION_MODULES, mergePermissions } from './permissionModules';
import PermissionMatrix from './PermissionMatrix';

export const SubAdminList = () => {
    const [list, setList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [search, setSearch] = useState('');
    const [page, setPage] = useState(1);
    const [total, setTotal] = useState(0);
    const limit = 15;

    const [showPerm, setShowPerm] = useState(false);
    const [selected, setSelected] = useState(null);
    const [permissions, setPermissions] = useState(mergePermissions({}));

    useEffect(() => { load(); /* eslint-disable-next-line */ }, [page]);

    function load() {
        setLoading(true);
        Api.post('roles/sub-admins/list', { page, limit, search }).then((r) => r.data).then((res) => {
            setLoading(false);
            if (res.status == 1) { setList(res.data || []); setTotal(res.total || 0); }
            else { Alert.error(res.message); }
        }).catch(() => setLoading(false));
    }

    function onSearch(e) { e.preventDefault(); if (page !== 1) setPage(1); else load(); }

    function openPerm(admin) {
        setSelected(admin);
        setPermissions(mergePermissions(admin.permissions));
        setShowPerm(true);
    }
    function savePerm() {
        Api.post('roles/sub-admins/update-permissions', { id: selected._id, permissions }).then((r) => r.data).then((res) => {
            if (res.status == 1) { Alert.success(res.message); setShowPerm(false); load(); }
            else { Alert.error(res.message); }
        });
    }
    function toggleStatus(admin) {
        Api.post('roles/sub-admins/status', { id: admin._id }).then((r) => r.data).then((res) => {
            if (res.status == 1) { Alert.success(res.message); load(); } else { Alert.error(res.message); }
        });
    }
    function onDelete(admin) {
        Alert.warning('Delete this sub-admin? This revokes their access immediately.').then((result) => {
            if (result.isConfirmed) {
                Api.post('roles/sub-admins/delete', { id: admin._id }).then((r) => r.data).then((res) => {
                    if (res.status == 1) { Alert.success(res.message); load(); } else { Alert.error(res.message); }
                });
            }
        });
    }

    function permPreview(perms) {
        const p = mergePermissions(perms);
        const active = PERMISSION_MODULES.filter((m) => p[m.key].read || p[m.key].write || p[m.key].delete);
        if (active.length === 0) return <span className="text-muted">None</span>;
        const first = active.slice(0, 3).map((m) => m.label).join(', ');
        return <span>{first}{active.length > 3 ? ' +' + (active.length - 3) + ' more' : ''}</span>;
    }

    const totalPages = Math.max(1, Math.ceil(total / limit));

    return (
        <section className="main-content">
            <div className="page-content">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="card">
                                <div className="card-body">
                                    <div className="d-flex justify-content-between align-items-center mb-3">
                                        <h4 className="card-title mb-0">Roles &amp; Permissions — Sub-Admins</h4>
                                        <Link to="/roles/sub-admins/add" className="btn btn-primary btn-sm">+ Add Sub-Admin</Link>
                                    </div>
                                    <form className="mb-3" onSubmit={onSearch}>
                                        <div className="input-group" style={{ maxWidth: 360 }}>
                                            <input className="form-control" placeholder="Search name or email" value={search} onChange={(e) => setSearch(e.target.value)} />
                                            <div className="input-group-append"><button className="btn btn-outline-secondary" type="submit">Search</button></div>
                                        </div>
                                    </form>
                                    <div className="table-responsive">
                                        <table className="table align-middle table-nowrap mb-0">
                                            <thead className="table-light">
                                                <tr><th>Name</th><th>Email</th><th>Permissions</th><th>Status</th><th>Action</th></tr>
                                            </thead>
                                            <tbody>
                                                {loading && <tr><td colSpan="5" className="text-center">Loading…</td></tr>}
                                                {!loading && list.length === 0 && <tr><td colSpan="5" className="text-center">No sub-admins found</td></tr>}
                                                {!loading && list.map((a) => (
                                                    <tr key={a._id}>
                                                        <td>{((a.firstname || '') + ' ' + (a.lastname || '')).trim() || '-'}</td>
                                                        <td>{a.email}</td>
                                                        <td>{permPreview(a.permissions)}</td>
                                                        <td>{a.status == 1 ? <span className="badge badge-success">Active</span> : <span className="badge badge-danger">Inactive</span>}</td>
                                                        <td>
                                                            <button className="btn btn-sm btn-outline-info mr-1" onClick={() => openPerm(a)}>Permissions</button>
                                                            <Link to={'/roles/sub-admins/edit/' + a._id} className="btn btn-sm btn-outline-secondary mr-1">Edit</Link>
                                                            <button className="btn btn-sm btn-outline-warning mr-1" onClick={() => toggleStatus(a)}>{a.status == 1 ? 'Deactivate' : 'Activate'}</button>
                                                            <button className="btn btn-sm btn-outline-danger" onClick={() => onDelete(a)}>Delete</button>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                    <div className="d-flex justify-content-between align-items-center mt-3">
                                        <small>Total: {total}</small>
                                        <div>
                                            <button className="btn btn-sm btn-outline-secondary mr-2" disabled={page <= 1} onClick={() => setPage(page - 1)}>Prev</button>
                                            <span>Page {page} / {totalPages}</span>
                                            <button className="btn btn-sm btn-outline-secondary ml-2" disabled={page >= totalPages} onClick={() => setPage(page + 1)}>Next</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Modal show={showPerm} onHide={() => setShowPerm(false)} size="lg" scrollable>
                <Modal.Header closeButton><Modal.Title>Permissions — {selected ? selected.email : ''}</Modal.Title></Modal.Header>
                <Modal.Body><PermissionMatrix permissions={permissions} setPermissions={setPermissions} /></Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowPerm(false)}>Cancel</Button>
                    <Button variant="primary" onClick={savePerm}>Save Permissions</Button>
                </Modal.Footer>
            </Modal>
        </section>
    );
};
export default withRouter(SubAdminList);
